// test782
(782 && 0);
